import * as types from '../../mutation-types';
import dbConnector from '../../api/dbConnector';
import Vue from "vue";

const state = {
  all: [],
  activeComments: [],
  activeArticle: {},
  comments: [],
};

const getters = {
  allNews: state => state.all,
  commentsById () {
    const commentObj = {};
    state.comments.forEach(comment => {
      if (!commentObj[comment.news_ref_id]) commentObj[comment.news_ref_id] = [];
      commentObj[comment.news_ref_id].splice(1, 0, comment);
    });
    return commentObj;
  },
  activeArticle: state => state.activeArticle,
  activeComments: state => state.activeComments,
};

const actions = {
  getAllNews ({commit}, cb) {
    dbConnector.getContentNews(news => {
      commit(types.RECEIVE_NEWS, {news});
      if (cb) cb();
    });
  },
  getAllComments({commit}, cb) {
    dbConnector.getContentComments(comments => {
      commit(types.RECEIVE_NEWS_COMMENTS, {comments});
      if (cb) cb();
    });
  },
  likeNews ({commit}, {item, val, user_id, cb}) {
    commit(types.PUT_NEWS_ITEM, {item, val, user_id, cb});
  },
  likeNewsComment ({commit}, {comment, val, user_id, cb, news_id}) {
    commit(types.PUT_NEWS_ITEM_COMMENT, {comment, val, user_id, cb, news_id});
  },
  setActiveComment({commit}, id){
    commit(types.SET_ACTIVE_COMMENT, {id});
  },
  setActiveArticle({commit}, item){
    commit(types.SET_ACTIVE_ARTICLE, {item});
  },
};

const mutations = {
  [types.RECEIVE_NEWS] (state, {news}) {
    state.all = news;
  },
  [types.RECEIVE_NEWS_COMMENTS] (state, {comments}){
    state.comments = comments.slice().reverse();
  },
  [types.SET_ACTIVE_COMMENT] (state, {id}){
    if (getters.commentsById()[id]) state.activeComments = getters.commentsById()[id];
    else state.activeComments = [];
  },
  [types.SET_ACTIVE_ARTICLE] (state, {item}){
    state.activeArticle = item;
  },
  [types.PUT_NEWS_ITEM] (state, {item, val, user_id, cb}) {
    // console.log('PUT_NEWS_ITEM');
    const local = state.all.filter((localItem) => item.id === localItem.id);
    // console.log(local);
    const like = 0;

    let points = 0;
    if (item.likes_favorite.indexOf('.') === 0) local[0].likes_favorite = '';
    if (item.likes.indexOf('.') === 0) local[0].likes = '';
    if (val === 'like') {
      if (item.likes.indexOf(user_id) === -1) {
        if (item.likes_favorite.indexOf(user_id) > -1) {
          local[0].likes_favorite = local[0].likes_favorite.replace(`${user_id},`, '');
          points -= 1;
        }
        local[0].likes = `${item.likes + user_id},`;
        points += 1;
      } else {
        local[0].likes = local[0].likes.replace(`${user_id},`, '');
        points = -1;
      }
    } else if (val === 'favorite') {
      if (item.likes_favorite.indexOf(user_id) === -1) {
        if (item.likes.indexOf(user_id) > -1) {
          local[0].likes = local[0].likes.replace(`${user_id},`, '');
          points -= 1;
        }
        local[0].likes_favorite = `${item.likes_favorite + user_id},`;
        points += 1;
      } else {
        local[0].likes_favorite = local[0].likes_favorite.replace(`${user_id},`, '');
        points = -1;
      }
    }

    /*   if (val === 'favorite') {
     if (!item.toggleLike && !item.toggleLikeFavorite) {
     item.toggleLike = false;
     item.toggleLikeFavorite = true;
     local[0].likes_favorite = `${local[0].likes_favorite},${user_id}`;
     } else if (!item.toggleLike && item.toggleLikeFavorite) {
     item.toggleLike = false;
     item.toggleLikeFavorite = false;
     local[0].likes_favorite = parseInt(local[0].likes_favorite, 10) - 1;
     } else if (item.toggleLike && !item.toggleLikeFavorite) {
     item.toggleLike = false;
     item.toggleLikeFavorite = true;
     local[0].likes_favorite = `${local[0].likes_favorite},${user_id}`;
     local[0].likes = parseInt(local[0].likes, 10) - 1;
     }
     }
     else if (!item.toggleLike && !item.toggleLikeFavorite) {
     item.toggleLike = true;
     item.toggleLikeFavorite = false;
     local[0].likes = parseInt(local[0].likes, 10) + 1;
     } else if (item.toggleLike && !item.toggleLikeFavorite) {
     item.toggleLike = false;
     item.toggleLikeFavorite = false;
     local[0].likes = parseInt(local[0].likes, 10) - 1;
     } else if (!item.toggleLike && item.toggleLikeFavorite) {
     item.toggleLike = true;
     item.toggleLikeFavorite = false;
     local[0].likes = parseInt(local[0].likes, 10) + 1;
     local[0].likes_favorite = parseInt(local[0].likes_favorite, 10) - 1;
     }
     // console.log(like);
     like += 1;
     // console.log(like); */
    if (item.likes_favorite.length === 0) local[0].likes_favorite = '.';
    if (item.likes.length === 0) local[0].likes = '.';
// local[0] = item;

    dbConnector.putNewsItem(local[0]);
    cb({user_id, points});
  },
  [types.PUT_NEWS_ITEM_COMMENT] (state, {comment, val, user_id, cb, news_id}) {
    // console.log('PUT_NEWS_ITEM_COMMENT');
    const local = [];
    local.push(comment);
    // console.log(local);
    const like = 0;

    let points = 0;
    if (comment.likes_favorite.indexOf('.') === 0) local[0].likes_favorite = '';
    if (comment.likes.indexOf('.') === 0) local[0].likes = '';
    if (val === 'like') {
      if (comment.likes.indexOf(user_id) === -1) {
        if (comment.likes_favorite.indexOf(user_id) > -1) {
          local[0].likes_favorite = local[0].likes_favorite.replace(`${user_id},`, '');
          points -= 1;
        }
        local[0].likes = `${comment.likes + user_id},`;
        points += 1;
      } else {
        local[0].likes = local[0].likes.replace(`${user_id},`, '');
        points = -1;
      }
    } else if (val === 'favorite') {
      if (comment.likes_favorite.indexOf(user_id) === -1) {
        if (comment.likes.indexOf(user_id) > -1) {
          local[0].likes = local[0].likes.replace(`${user_id},`, '');
          points -= 1;
        }
        local[0].likes_favorite = `${comment.likes_favorite + user_id},`;
        points += 1;
      } else {
        local[0].likes_favorite = local[0].likes_favorite.replace(`${user_id},`, '');
        points = -1;
      }
    }

    if (comment.likes_favorite.length === 0) local[0].likes_favorite = '.';
    if (comment.likes.length === 0) local[0].likes = '.';
// local[0] = item;

    dbConnector.putNewsComment(local[0]);
    cb({user_id, points});
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
